import Vue from "vue";
import axios from 'axios';

const version = 'v1';
const getAllSalesHandlersApi = `${version}/Sales`;
const updateSalesApi = `${version}/Sales`;
const addSalesHandlersApi = `${version}/Sales`;
const deleteSalesApi = `${version}/Sales`;

export const state = Vue.observable({
    salesHandlers: [],
    salesHandlersCount: 0
});
export const mutations = {
    async getSales(params = {}) {
        var res = await axios.get(getAllSalesHandlersApi, params);
        state.salesHandlers = res?.data;
        state.salesHandlersCount = res?.data?.result?.totalCount;
    },
    async updateUser(sales) {
        await axios.put(`${updateSalesApi}`, sales);
        await this.getSales();
    },
    async addSales(sales) {
        await axios.post(`${addSalesHandlersApi}`, sales);
        await this.getSales();
    },
    async deleteSales(id) {
        var res = await axios.delete(`${deleteSalesApi}/?id=${id}`);
        await this.getSales();
        return res?.data;
    }


};